import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from '../base.form.component';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['../base.form.scss']
})
export class EmailComponent extends BaseFormComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
